<template>
  <div>
    <div class="w-100 mb-4">
      <div class="w-50 ml-2">
        <Tabs :tabSelected="tabSelected" :tabs="tabs" :disabled="!loading || !loadingTotal"
          @change="changeTab($event)" />
      </div>
    </div>
    <div class="card p-2">
      <div class="float-left mr-5">
        <FilterSystem class="float-left mt-1" :columns="contactColumns" :reset="resetFilterSystem" :sort="sort"
          :dir="dir" :filterSystem="searchFilter" :filterOldQuery="oldQuery" :key="filterkey"
          :disabled="!loading || !loadingTotal" @callApi="filterNow($event)" />
        <div class="row text-right"
          v-if="tabSelected == 1 && this.currentUser.role_id == 1 && this.currentUser.user_constraint_id == null">
          <div class="col-12 mt-2 mb-2">
            <button class="btn btn-danger px-2 ml-3"
              :disabled="!loading || !loadingTotal || model.selectedIds.length == 0"
              @click="unsubscribeContact(model.selectedIds)">{{ $t('lang.button.unsubscribeall') }}</button>
            <button class="btn btn-warning px-2 ml-3"
              :disabled="!loading || !loadingTotal || model.selectedIds.length == 0"
              @click="changeBusinessContactStatusByLinkId(model.selectedIds)">{{ $t('lang.button.donotcontact')
              }}</button>
            <button class="btn btn-success px-2 ml-3"
              :disabled="!loading || !loadingTotal || model.selectedIds.length == 0"
              @click="createTaskColdphoning(model.selectedIds)">{{ $t('lang.button.created_cold') }}</button>
          </div>
        </div>
      </div>
      <LoadingSpinner v-if="!loading || !loadingTotal" />
      <div class="animated fadeIn faster m-2" v-else>
        <div class="row">
          <div class="col-12">
            <div class="bd-highlight">
              {{ $t("lang.label.results") }}:
              <small v-if="total == null || total == undefined" class="ml-1 text-primary">{{
                $t("lang.search.calculating") }}...</small>
              <strong v-else>{{ total }}</strong>
              <button class="ml-2 btn btn-sm btn-primary" @click="getToDownload()" :disabled="processingAllItems">
                <span v-if="!processingAllItems">
                  Download csv
                </span>
                <span v-else>Processing...</span>
              </button>
            </div>
            <div class="text-center">
              <Pagination :total="total" :totalpage="totalPageStep" :model="pagination" :limit="false"
                :color="'primary'" @changePage="changePage" key="paginationkey"></Pagination>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-12">
            <div class="mx-0 px-0 table-responsive">
              <!-- TABLE ENVOIS -->
              <Table v-if="tabSelected == 1" class="mx-2 w-100"
                :headers="hideColumnActions() ? headerSales : headerAdmin" :cols="cols" :data="arrayList"
                :fieldsLoading="fieldsLoading" :checkbox="true" :allpageselected="false" :allselected="false"
                :model="model" :fromContacts="true" :key="100" @goToOpportunity="goToOpportunity"
                @goToLinkedin="goToLinkedin" @toggleSelectedRows="toggleSelectedRows($event)"
                @select-all-pages-changed="isSelectAllPages = $event">
              </Table>
              <!-- TABLE NOT IN SEQUENCE -->
              <Table v-if="tabSelected == 2 || tabSelected == 3" class="mx-2 w-100" :headers="headersAvailable"
                :cols="colsAvailable" :data="arrayList" :checkbox="false" :notselect="true"
                :fieldsLoading="fieldsLoading" :key="100" @goToLinkedin="goToLinkedin">
              </Table>
            </div>
          </div>
        </div>

        <div class="row mt-4" v-if="tabSelected == 1">
          <div class="col-md-12">
            <div class="mx-0 px-0 table-responsive">
              <!-- TABLE ENVOIS STADISTIC STEPS -->
              <Table class="mx-2 w-100" :headers="headersTotals" :cols="colsTotals" :data="stepTotals" :checkbox="false"
                :notselect="true" :fieldsLoading="fieldsLoading" :key="100">
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import Header from "@/components/Header.vue";
import { businessContactsService, targetsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Table from "@/components/Common/Table.vue";
import Tabs from "@/components/Common/Tabs.vue";
import FilterSystem from "@/components/FilterSystem.vue";
import Pagination from "@/components/Common/Pagination.vue";
export default {
  data() {
    return {
      processingAllItems: false,
      typeListSelected: "lastemails",
      selectedRows: [],
      isSelectAllPages: false,
      checkBilling: false,
      selectAllRows: false,
      currentPage: 1,
      cantPerPage: 50,
      cantPerPageOptions: [5, 10, 20, 50, 100],
      fieldsLoading: true,
      loading: true,
      loadingTotal: true,
      total: 0,
      model: {
        selectedIds: [],
        allselected: false,
        allpageselected: false,
      },
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 100,
        currentPage: 1,
      },
      typeStatus: {
        1: "Scheduled",
        2: "Sent",
        3: "Bounced",
      },
      filters: [],
      lastFilters: [],
      filtersSequence: [],
      lastFiltersSequence: [],
      arrayList: [],
      arrayListAllItems: [],
      totalStats: [],
      stepTotals: [],
      stepStatus: 1,
      stepDate: null,
      onlyTotal: 1,
      resetFilterSystem: false,
      sort: "",
      dir: "",
      filterkey: 2233,
      filterSystem: {},
      searchFilter: {},
      oldQuery: "  ",
      tabSelected: 1,
      tabs: {
        1: {
          id: 1,
          name: this.$t("lang.label.contacts_engaged"),
        },
        2: {
          id: 2,
          name: this.$t("lang.label.contacts_attente"),
        },
        3: {
          id: 3,
          name: this.$t("lang.label.contacts_block"),
        },
      },
      contactColumns: [
        {
          name: this.$t("lang.column.lastname"),
          name_: "lastname",
          type: "string",
          field: "bc.last_name",
        },
        {
          name: this.$t("lang.column.firstname"),
          name_: "firstname",
          type: "string",
          field: "bc.first_name",
        },
        {
          name: this.$t("lang.column.contact_email"),
          name_: "email",
          type: "string",
          field: "bc.email",
        },
        {
          name: this.$t("lang.column.prospector_email"),
          name_: "email",
          type: "string",
          field: "ow.email",
        },
        {
          name: this.$t("lang.column.jobtitle"),
          name_: "jobtitle",
          type: "string",
          field: "bc.job",
        },
        {
          name: this.$t("lang.column.companysizemin"),
          name_: "salariesmin",
          type: "number",
          field: "salariesmin",
        },
        {
          name: this.$t("lang.column.companysizemax"),
          name_: "salaries",
          type: "number",
          field: "salaries",
        },
        {
          name: this.$t("lang.column.status_sequence"),
          name_: "is_active",
          type: "list",
          list: [
            { id: "1", name: this.$t("lang.label.active") },
            { id: "0", name: this.$t("lang.label.inactive") },
          ],
          field: "is_active",
          having: true,
        },
        {
          name: this.$t("lang.column.contact_phone"),
          name_: "phone",
          type: "list",
          list: [
            { id: true, name: this.$t("lang.button.yes") },
            { id: false, name: this.$t("lang.label.no") },
          ],
          field: "phone",
          having: true,
        },
        {
          name: "Cold Task",
          name_: "has_cold_tasks",
          type: "list",
          list: [
            { id: true, name: this.$t("lang.button.yes") },
            { id: false, name: this.$t("lang.label.no") },
          ],
          field: "has_cold_tasks",
          having: true,
        },
      ],
      headersAvailable: [
        {
          label: "Photo",
          percentage: "0.1%",
          class: "overflowhide",
        },
        {
          label: "Contact name",
          class: "overflowhide",
          percentage: "5%",
        },
        {
          label: "Contact company",
          class: "overflowhide",
          percentage: "5%",
        },
        {
          label: "Contact email",
          class: "overflowhide",
          percentage: "5%",
        },
        {
          label: "Status Reason",
          class: "overflowhide",
          percentage: "5%",
        },
      ],
      colsAvailable: [
        [
          {
            value: "photo",
            type: "image",
            width: "25px",
          },
        ],
        [
          {
            value_label: "contact_name",
            value_emit: "linkedinurl",
            class: "text-primary font-weight-bold table-small",
            type: "emit",
            emit: "goToLinkedin",
          },
        ],
        [
          {
            value: "business_name",
          },
          // {
          //   value_label: "business_name", //contacto de compañia
          //   tooltip: "business_name",
          //   value_emit: "id",
          //   class: "text-primary font-weight-bold table-small",
          //   type: "emit",
          //   emit: "goToOpportunity",
          // },
        ],
        [
          {
            value: "email", // email contacto
            tooltip: "email",
          },
        ],
        [
          {
            value: "reason_status",
            value_label: "reason_status",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "POSITIVE (OPP)",
                label: "POSITIVE (OPP)",
                bgColor: "#4AF92B",
                textColor: "#FFFFFF",
              },
              {
                id: "POSITIVE (REP)",
                label: "POSITIVE (REP)",
                bgColor: "#4AF92B",
                textColor: "#FFFFFF",
              },
              {
                id: "NEGATIVE (OPP)",
                label: "NEGATIVE (OPP)",
                bgColor: "#EC0303",
                textColor: "#FFFFFF",
              },
              {
                id: "NEGATIVE (REP)",
                label: "NEGATIVE (REP)",
                bgColor: "#EC0303",
                textColor: "#FFFFFF",
              },
              {
                id: "DO NOT CONTACT (OPP)",
                label: "DO NOT CONTACT (OPP)",
                bgColor: "#DEDEDE",
                textColor: "#000000",
              },
              {
                id: "DO NOT CONTACT (REP)",
                label: "DO NOT CONTACT (REP)",
                bgColor: "#DEDEDE",
                textColor: "#000000",
              },
              {
                id: "NOT SCOPE (OPP)",
                label: "NOT SCOPE (OPP)",
                bgColor: "#E9961F",
                textColor: "#FFFFFF",
              },
              {
                id: "NOT SCOPE (REP)",
                label: "NOT SCOPE (REP)",
                bgColor: "#E9961F",
                textColor: "#FFFFFF",
              },
              {
                id: "WRONG (OPP)",
                label: "WRONG (OPP)",
                bgColor: "#949494",
                textColor: "#FFFFFF",
              },
              {
                id: "WRONG (REP)",
                label: "WRONG (REP)",
                bgColor: "#949494",
                textColor: "#FFFFFF",
              },
              {
                id: "INTRODUCTION (OPP)",
                label: "INTRODUCTION (OPP)",
                bgColor: "#217EF5",
                textColor: "#FFFFFF",
              },
              {
                id: "INTRODUCTION (REP)",
                label: "INTRODUCTION (REP)",
                bgColor: "#217EF5",
                textColor: "#FFFFFF",
              },
              {
                id: "URGENT (OPP)",
                label: "URGENT (OPP)",
                bgColor: "#FEE025",
                textColor: "#FFFFFF",
              },
              {
                id: "URGENT (REP)",
                label: "URGENT (REP)",
                bgColor: "#FEE025",
                textColor: "#FFFFFF",
              },
              {
                id: "OTHER ANSWER (OPP)",
                label: "OTHER ANSWER (OPP)",
                bgColor: "#A741F2",
                textColor: "#FFFFFF",
              },
              {
                id: "OTHER ANSWER (REP)",
                label: "OTHER ANSWER (REP)",
                bgColor: "#A741F2",
                textColor: "#FFFFFF",
              },
              {
                id: "OLV-OFF",
                label: "OLV-OFF",
                bgColor: "#FFFF00",
                textColor: "#000000",
              },
              {
                id: "BLACKLIST",
                label: "BLACKLIST",
                bgColor: "#000000",
                textColor: "#FFFFFF",
              },
              {
                id: "BOUNCED",
                label: "BOUNCED",
                bgColor: "#01FAE0",
                textColor: "#FFFFFF",
              },
              {
                id: "NOT-SCOPE",
                label: "NOT SCOPE",
                bgColor: "#88BA48",
                textColor: "#FFFFFF",
              },
              {
                id: "OPT-OUT",
                label: "OPT-OUT",
                bgColor: "#DEDEDE",
                textColor: "#000000",
              },
              {
                id: "MEETING",
                label: "MEETING",
                bgColor: "#F349DC",
                textColor: "#FFFFFF",
              },
              {
                id: "ORDER-PAUSED",
                label: "ORDER PAUSED",
                bgColor: "#A46B42",
                textColor: "#FFFFFF",
              },
              {
                id: "AVAILABLE",
                label: "AVAILABLE",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "ENRICHING",
                label: "ENRICHING",
                bgColor: "orange",
                textColor: "#FFFFFF",
              },
              {
                id: "EMAIL NOT FOUND",
                label: "EMAIL NOT FOUND",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "NOT AVAILABLE",
                label: "NOT AVAILABLE",
                bgColor: "yellow",
                textColor: "black",
              },
            ],
          },
        ],
      ],
      cols: [
        [
          {
            value: "id",
            emit: "toggleSelectedRows",
            type: "chkBoxContacts",
          },
        ],
        [
          {
            value_label: "contact_name",
            value_emit: "linkedinurl",
            class: "text-primary font-weight-bold table-small",
            type: "emit",
            emit: "goToLinkedin",
          },
        ],
        [
          {
            value_label: "business_name", //contacto de compañia
            tooltip: "business_name",
            value_emit: "id",
            class: "text-primary font-weight-bold table-small",
            type: "emit",
            emit: "goToOpportunity",
          },
        ],
        [
          {
            value: "email", // email contacto
            tooltip: "email",
          },
        ],
        [
          {
            value: "jobtitle",
            tooltip: "jobtitle",
          },
        ],
        [
          {
            value: "phone",
            value3: "phone_updated",
            value2: "source_phone",
            value4: "phone_updated",
            phoneTool: 1,
            type: "tooltipNote",
          },
          {
            condition: "failed_count >= 3",
            value_if: "failed_count",
            value_label: "Wrong Contact",
            type: "bubble",
            class: "w-100 badge bg-danger text-white p-2",
          },

        ],
        [
          {
            value: "prospector_email", //email prospector
            tooltip: "prospector_email",
          },
        ],
        [
          {
            // value: "cold_task_done"
            value1: "cold_task_open",
            value2: "cold_task_open_date",
            value3: "cold_task_closed",
            value4: "cold_task_closed_first_date",
            value5: "cold_task_closed_last_date",
            format: "has_cold_tasks",
            type: "iconIfPipe",
          }
        ],
        [
          {
            value: "is_active",
            value_label: "is_active",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "1",
                label: "Active",
                bgColor: "#34F148",
                textColor: "#FFFFFF",
              },
              {
                id: "0",
                label: "Inactive",
                bgColor: "gray",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            value: "reason_status",
            value_label: "reason_status",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "POSITIVE (OPP)",
                label: "POSITIVE (OPP)",
                bgColor: "#4AF92B",
                textColor: "#FFFFFF",
              },
              {
                id: "POSITIVE (REP)",
                label: "POSITIVE (REP)",
                bgColor: "#4AF92B",
                textColor: "#FFFFFF",
              },
              {
                id: "NEGATIVE (OPP)",
                label: "NEGATIVE (OPP)",
                bgColor: "#EC0303",
                textColor: "#FFFFFF",
              },
              {
                id: "NEGATIVE (REP)",
                label: "NEGATIVE (REP)",
                bgColor: "#EC0303",
                textColor: "#FFFFFF",
              },
              {
                id: "DO NOT CONTACT (OPP)",
                label: "DO NOT CONTACT (OPP)",
                bgColor: "#DEDEDE",
                textColor: "#000000",
              },
              {
                id: "DO NOT CONTACT (REP)",
                label: "DO NOT CONTACT (REP)",
                bgColor: "#DEDEDE",
                textColor: "#000000",
              },
              {
                id: "NOT SCOPE (OPP)",
                label: "NOT SCOPE (OPP)",
                bgColor: "#E9961F",
                textColor: "#FFFFFF",
              },
              {
                id: "NOT SCOPE (REP)",
                label: "NOT SCOPE (REP)",
                bgColor: "#E9961F",
                textColor: "#FFFFFF",
              },
              {
                id: "WRONG (OPP)",
                label: "WRONG (OPP)",
                bgColor: "#949494",
                textColor: "#FFFFFF",
              },
              {
                id: "WRONG (REP)",
                label: "WRONG (REP)",
                bgColor: "#949494",
                textColor: "#FFFFFF",
              },
              {
                id: "INTRODUCTION (OPP)",
                label: "INTRODUCTION (OPP)",
                bgColor: "#217EF5",
                textColor: "#FFFFFF",
              },
              {
                id: "INTRODUCTION (REP)",
                label: "INTRODUCTION (REP)",
                bgColor: "#217EF5",
                textColor: "#FFFFFF",
              },
              {
                id: "URGENT (OPP)",
                label: "URGENT (OPP)",
                bgColor: "#FEE025",
                textColor: "#FFFFFF",
              },
              {
                id: "URGENT (REP)",
                label: "URGENT (REP)",
                bgColor: "#FEE025",
                textColor: "#FFFFFF",
              },
              {
                id: "OTHER ANSWER (OPP)",
                label: "OTHER ANSWER (OPP)",
                bgColor: "#A741F2",
                textColor: "#FFFFFF",
              },
              {
                id: "OTHER ANSWER (REP)",
                label: "OTHER ANSWER (REP)",
                bgColor: "#A741F2",
                textColor: "#FFFFFF",
              },
              {
                id: "OLV-OFF",
                label: "OLV-OFF",
                bgColor: "#FFFF00",
                textColor: "#000000",
              },
              {
                id: "BLACKLIST",
                label: "BLACKLIST",
                bgColor: "#000000",
                textColor: "#FFFFFF",
              },
              {
                id: "BOUNCED",
                label: "BOUNCED",
                bgColor: "#01FAE0",
                textColor: "#FFFFFF",
              },
              {
                id: "NOT-SCOPE",
                label: "NOT SCOPE",
                bgColor: "#88BA48",
                textColor: "#FFFFFF",
              },
              {
                id: "OPT-OUT",
                label: "OPT-OUT",
                bgColor: "#DEDEDE",
                textColor: "#000000",
              },
              {
                id: "MEETING",
                label: "MEETING",
                bgColor: "#F349DC",
                textColor: "#FFFFFF",
              },
              {
                id: "ORDER-PAUSED",
                label: "ORDER PAUSED",
                bgColor: "#A46B42",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            value: "_step1_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step1",
            tooltip: "_step1_status_name",
          },
        ],
        [
          {
            value: "_step2_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step2",
            tooltip: "_step2_status_name",
          },
        ],
        [
          {
            value: "_step3_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step3",
            tooltip: "_step3_status_name",
          },
        ],
        [
          {
            value: "_step4_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step4",
            tooltip: "_step4_status_name",
          },
        ],
        [
          {
            value: "_step5_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step5",
            tooltip: "_step5_status_name",
          },
        ],
        [
          {
            value: "_step6_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step6",
            tooltip: "_step6_status_name",
          },
        ],
        // [
        //   {
        //     btnId: "id",
        //     name: "Action",
        //     value_if: "link_id",
        //     type: "btnIfNotNull",
        //     emit: "openModalActions",
        //   },
        // ],
      ],

      colsTotals: [
        [
          {
            value_label: "total_in_contact",
          },
        ],
        [
          {
            value_label: "empty_field", //contacto de compañia
          },
        ],
        [
          {
            value: "empty_field", // email contacto
          },
        ],
        [
          {
            value: "empty_field", //email prospector
          },
        ],
        [
          {
            value: "empty_field",
          },
        ],
        [
          {
            value: "empty_field",
          },
        ],
        [
          {
            value: "_step1_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step1",
            tooltip: "_step1_status_name",
          },
        ],
        [
          {
            value: "_step2_status",
            show_text: "false",

            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step2",
            tooltip: "_step2_status_name",
          },
        ],
        [
          {
            value: "_step3_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step3",
            tooltip: "_step3_status_name",
          },
        ],
        [
          {
            value: "_step4_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step4",
            tooltip: "_step4_status_name",
          },
        ],
        [
          {
            value: "_step5_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step5",
            tooltip: "_step5_status_name",
          },
        ],
        [
          {
            value: "_step6_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "2",
                icon_true: "icon-check-circle text-success icon-small",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-clock text-warning icon-small-clock",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-times-circle text-danger icon-small",
              },
            ],
          },
          {
            value: "_step6",
            tooltip: "_step6_status_name",
          },
        ],
      ],

      headersTotals: [
        // {
        //   label: "",
        //   class: "overflowhide",
        //   percentage: "0%",
        //   size: "50px",
        // },
        {
          label: "",
          class: "overflowhide",
          percentage: "0%",
          size: "30px",
        },
        {
          label: "",
          class: "overflowhide",
          percentage: "0%",
          size: "30px",
        },
        {
          label: "",
          class: "overflowhide",
          percentage: "0%",
          size: "0px",
        },
        {
          label: "",
          class: "overflowhide",
          percentage: "0%",
          size: "0px",
        },
        {
          label: "",
          class: "overflowhide",
          percentage: "0%",
          size: "0px",
        },
        {
          label: "Step 1",
          class: "overflowhide",
          percentage: "18%",
          size: "71px",
        },
        {
          label: "Step 2",
          class: "overflowhide",
          percentage: "18%",
          size: "70px",
        },
        {
          label: "Step 3",
          class: "overflowhide",
          percentage: "18%",
          size: "70px",
        },
        {
          label: "Step 4",
          class: "overflowhide",
          percentage: "18%",
          size: "70px",
        },
        {
          label: "Step 5",
          class: "overflowhide",
          percentage: "18%",
          size: "70px",
        },
        {
          label: "Step 6",
          class: "overflowhide",
          percentage: "18%",
          size: "70px",
        },
      ],

      headerAdmin: [
        {
          label: "Contact name",
          class: "overflowhide",
          percentage: "5%",
          size: "90px",
        },
        {
          label: "Contact company",
          class: "overflowhide",
          percentage: "5%",
          size: "90px",
        },
        {
          label: "Contact email",
          class: "overflowhide",
          percentage: "5%",
          size: "150px",
        },
        {
          label: "Contact job",
          class: "overflowhide",
          percentage: "5%",
          size: "150px",
        },
        {
          label: "Contact Phone",
          class: "overflowhide",
          percentage: "5%",
          size: "90px",
        },
        {
          label: "Prospector email",
          class: "overflowhide",
          percentage: "5%",
          size: "150px",
        },
        {
          label: "Cold Task",
          class: "overflowhide",
          percentage: "5%",
          size: "125px",
        },
        {
          label: "Sequence",
          class: "overflowhide",
          percentage: "5%",
          size: "70px",
        },
        {
          label: "Last interaction",
          class: "overflowhide",
        },
        {
          label: "Step 1",
          class: "overflowhide",
          percentage: "10%",
        },
        {
          label: "Step 2",
          class: "overflowhide",
          percentage: "10%",
        },
        {
          label: "Step 3",
          class: "overflowhide",
          percentage: "10%",
        },
        {
          label: "Step 4",
          class: "overflowhide",
          percentage: "10%",
        },
        {
          label: "Step 5",
          class: "overflowhide",
          percentage: "10%",
        },
        {
          label: "Step 6",
          class: "overflowhide",
          percentage: "10%",
        },
        // {
        //   label: "Actions",
        //   class: "overflowhide",
        //   percentage: "10%",
        // },
      ],
      headerSales: [
        {
          label: "Contact name",
          class: "overflowhide",
          percentage: "5%",
          size: "90px",
        },
        {
          label: "Contact company",
          class: "overflowhide",
          percentage: "5%",
          size: "90px",
        },
        {
          label: "Contact email",
          class: "overflowhide",
          percentage: "5%",
          size: "150px",
        },
        {
          label: "Prospector email",
          class: "overflowhide",
          percentage: "5%",
          size: "150px",
        },
        {
          label: "Sequence",
          class: "overflowhide",
          percentage: "5%",
          size: "70px",
        },
        {
          label: "Last interaction",
          class: "overflowhide",
        },
        {
          label: "Step 1",
          class: "overflowhide",
          percentage: "10%",
        },
        {
          label: "Step 2",
          class: "overflowhide",
          percentage: "10%",
        },
        {
          label: "Step 3",
          class: "overflowhide",
          percentage: "10%",
        },
        {
          label: "Step 4",
          class: "overflowhide",
          percentage: "10%",
        },
        {
          label: "Step 5",
          class: "overflowhide",
          percentage: "10%",
        },
        {
          label: "Step 6",
          class: "overflowhide",
          percentage: "10%",
        },
      ],
    };
  },

  props: {
    targetId: {
      type: String,
    },
  },

  components: {
    LoadingSpinner,
    Header,
    Table,
    Pagination,
    Tabs,
    FilterSystem,
  },

  computed: {
    totalPageStep() {
      return this.arrayList.length;
    },

    user() {
      return this.$store.state.authentication.user;
    },

    ...mapState({
      currentUser: (state) => state.authentication.user,
      stats: (state) => state.campaigns.stats.data,
      headerTab: (state) => state.header.tab,
    }),
    ...mapGetters('authentication', ['isSaleOrAccountExecutive']),
  },

  created() {
    this.getData();
  },

  methods: {
    getToDownload() {
      const allItems = 1; // cuando quieres pedir todos los resultados sin limite
      if (this.tabSelected == 2) {
        this.getNotInSequence(['AVAILABLE', 'ENRICHING'], allItems);
      } else if (this.tabSelected == 3) {
        this.getNotInSequence(['BOUNCED', 'DO NOT CONTACT', 'EMAIL NOT FOUND', 'NOT AVAILABLE', 'ORDER-PAUSED', 'OPT-OUT', 'OLV-OFF', 'NOT-SCOPE', 'BLACKLIST', 'ALREADY HAS EVENT'], allItems);
      } else {
        this.getData(allItems);
      }
    },
    download() {

      const currentHeaders = this.hideColumnActions() ? 'headerSales' : 'headerAdmin'

      let report = '-engaged_contacts'

      if (this.tabSelected == 2) {
        report = "-pending_contacts"
      } else if (this.tabSelected == 3) {
        report = "-blocked_contacts"
      }

      const nameDocument = "report-list" + report + ".csv";
      let headers
      let fields
      //Tomo headers desde simpleheader
      if (this.tabSelected == 2 || this.tabSelected == 3) {
        headers = this.headersAvailable.filter(el => el.label != 'Photo').map(h => h.label);
        fields = this.colsAvailable
          .filter(el => el[0].value != 'photo')
          .map(item => {
            const value = (item[0].value) ? item[0].value : item[0].value_label;
            return value;
          })
      } else {
        headers = this[currentHeaders].filter(el => el.label != 'Photo').map(h => h.label);

        fields = this.cols
          .filter(el => el[0].value != 'avatar' && el[0].value != 'id')
          .map((item, i) => {
            let value

            switch (i) {
              case 6:
                value = (item[0].value3) ? item[0].value3 : null
                break;
              case 9:
              case 10:
              case 11:
              case 12:
              case 13:
              case 14:
                value = (item[1].value) ? item[1].value : null
                break;
              default:
                value = (item[0].value) ? item[0].value : item[0].value_label;
                break;
            }

            return value;
          })
      }

      const rows = this.arrayListAllItems.map(item => {
        return fields.map(col => {
          if (this.tabSelected == 2 || this.tabSelected == 3) {

            return item[col];
          } else {
            if (col == 'is_active') {
              return (item[col] == 1) ? 'Active' : 'Inactive'
            }

            if (col == '_step1' || col == '_step2' || col == '_step3' ||
              col == '_step4' || col == '_step5' || col == '_step6') {
              if (item[col]) {
                const value = item[col]
                const parts = value.split("|")
                const datePart = parts[0]
                const label = parts[1]
                // Si trae fecha válida (ej: "2026-01-05|2"), mostrar la fecha
                if (datePart && moment(datePart, 'YYYY-MM-DD', true).isValid()) {
                  return moment(datePart).format('YYYY-MM-DD')
                }
                if (label) {
                  switch (label) {
                    case '1':
                      return 'Scheduled'

                    case '2':
                      return 'Sent'

                    default:
                      return 'Bounced'
                  }
                }
                return ''
              } else {
                return ''
              }
            }
            return item[col];
          }

        }).map(v => `"${String(v !== undefined && v !== null ? v : '').replace(/"/g, '""')}"`).join(",");
      })

      const csv = `${headers.join(",")}\n${rows.join("\n")}`;
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", nameDocument);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    hideColumnActions() {
      if (this.isSaleOrAccountExecutive) {
        return true;
      } else {
        return false;
      }
    },
    unsubscribeContact(array) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t(
          "lang.label.thiscontactwillbeunsubscribedfromthiscampaign"
        ),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.loading = false;
          this.loadingTotal = false;
          targetsService
            .unsubscribeContact(array, this.targetId)
            .then((res) => {
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                text: this.$t('lang.label.unsubscribeContactSuccess', { contacts: res.total_contacts, theme: res.success_count }),
                showConfirmButton: false,
                timer: 5000,
              });
              this.loading = true;
              this.loadingTotal = true;
            })
            .finally(() => {
              this.model.selectedIds = [];
              this.selectedRows = [];
              this.getData();
              this.getTotal();
            })
        }
      });
    },

    changeBusinessContactStatusByLinkId(array) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t(
          "lang.label.thiscontactwillbeunsubscribedfromthiscampaignand"
        ),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.loading = false;
          this.loadingTotal = false;
          targetsService
            .changeContactStatus(array, this.targetId, 7)
            .then((res) => {
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                text: this.$t('lang.label.changeBusinessContactStatusByLinkIdSuccess', { contacts: res.total_contacts, theme: res.success_count }),
                showConfirmButton: false,
                timer: 5000,
              });
              this.loading = true;
              this.loadingTotal = true;
            })
            .finally(() => {
              this.model.selectedIds = [];
              this.selectedRows = [];
              this.getData();
              this.getTotal();
            })
        }
      });
    },

    createTaskColdphoning(array) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t(
          "lang.label.thiscontactcreatednewcoldphoning"
        ),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.loading = false;
          this.loadingTotal = false;
          targetsService
            .setNewColdphoning(array, this.targetId, this.searchFilter, this.isSelectAllPages)
            .then((res) => {
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                text: this.$t('lang.label.createcoldphoningsuccess', { contacts: res.total_contacts, theme: res.created_tasks }),
                showConfirmButton: false,
                timer: 5000,
              });
              this.loading = true;
              this.loadingTotal = true;
            })
            .finally(() => {
              this.model.selectedIds = [];
              this.selectedRows = [];
              this.getData();
              this.getTotal();
            })
        }
      });
    },

    toggleSelectedRows(id) {

      if (this.model.selectedIds.includes(id)) {
        this.model.selectedIds = this.model.selectedIds.filter(x => x !== id);
      } else {
        this.model.selectedIds = [...this.model.selectedIds, id];
      }

      this.selectAllRows = this.model.selectedIds.length === this.arrayList.length;
    },

    filterNow(filter) {
      this.pagination.currentPage = 1;
      this.pagination.cantPerPage = 100;
      this.searchFilter = JSON.parse(JSON.stringify(filter));

      this.getDatabyTab()
    },

    changeTab(id) {
      if (this.tabSelected == id) return;
      this.pagination.currentPage = 1;
      this.pagination.cantPerPage = 100;
      this.searchFilter = {};
      this.oldQuery = "  ";
      this.tabSelected = id;

      this.getDatabyTab();

    },

    stepSeparate() {
      this.arrayList.forEach((item) => {
        for (let i = 1; i <= 6; i++) {
          const stepKey = `_step${i}`;
          const statusKey = `_step${i}_status`;

          if (item[stepKey] != null) {
            const [step, status] = item[stepKey].split("|");
            item[stepKey] = step;
            item[statusKey] = status;
            item[`${stepKey}_status_name`] = this.typeStatus[parseInt(status)]; //asigno el nombre del status a la posicion correspondiente
          }
        }
      });
    },

    goToOpportunity(id) {
      const selectedClient = this.arrayList.find((user) => user.id === id);
      if (selectedClient.link_id != null) {
        window.open("/opportunities/" + selectedClient.link_id, "_blank");
      }
    },

    goToLinkedin(id) {
      window.open(id, "_blank");
    },

    changePage() {
      this.getDatabyTab();
    },

    getDatabyTab() {
      switch (this.tabSelected) {
        case 1: //contacts engaged
          this.getData();
          this.getTotal();
          break;
        case 2: //Contacts en attente
          this.getNotInSequence(['AVAILABLE', 'ENRICHING']);
          this.getTotalNotInSequence(['AVAILABLE', 'ENRICHING']);
          break;
        case 3: //Contacts bloqués          
          this.getNotInSequence(['BOUNCED', 'DO NOT CONTACT', 'EMAIL NOT FOUND', 'NOT AVAILABLE', 'ORDER-PAUSED', 'OPT-OUT', 'OLV-OFF', 'NOT-SCOPE', 'BLACKLIST', 'ALREADY HAS EVENT']);
          this.getTotalNotInSequence(['BOUNCED', 'DO NOT CONTACT', 'EMAIL NOT FOUND', 'NOT AVAILABLE', 'ORDER-PAUSED', 'OPT-OUT', 'OLV-OFF', 'NOT-SCOPE', 'BLACKLIST', 'ALREADY HAS EVENT']);
          break;
        default:
          break;
      }
    },

    getNotInSequence(filterReasonStatus = [], allItems = 0) {
      this.onlyTotal = 0;

      if (allItems == 1) {
        this.processingAllItems = true;
      } else {
        this.loading = false;
      }
      this.filtersSequence.cantPerPage = this.pagination.cantPerPage;
      this.filtersSequence.currentPage = this.pagination.currentPage;
      this.filtersSequence.searchFilter = this.searchFilter;
      this.filtersSequence.only_total = 0;



      businessContactsService
        .getNotInSequence(
          this.pagination.cantPerPage,
          this.pagination.currentPage,
          this.targetId,
          this.onlyTotal,
          this.searchFilter,
          filterReasonStatus,
          allItems
        )
        .then((response) => {
          if (response) {
            if (allItems == 1) {
              this.arrayListAllItems = response.list;
              this.download()
              this.processingAllItems = false;
            } else {
              this.arrayList = response.list;
            }
          }
          this.lastFiltersSequence = this.filtersSequence;
          this.loading = true;
        });
    },

    getTotalNotInSequence(filterReasonStatus = []) {
      this.onlyTotal = 1;
      this.loadingTotal = false;
      this.filtersSequence.cantPerPage = this.pagination.cantPerPage;
      this.filtersSequence.currentPage = this.pagination.currentPage;
      this.filtersSequence.searchFilter = this.searchFilter;
      this.filtersSequence.only_total = 1;

      businessContactsService
        .getNotInSequence(
          this.pagination.cantPerPage,
          this.pagination.currentPage,
          this.targetId,
          this.onlyTotal,
          this.searchFilter,
          filterReasonStatus
        )
        .then((response) => {
          if (response) {
            this.total = response.total;
          }
          this.loadingTotal = true;
        });
    },

    getData(allItems = 0) {

      if (allItems == 1) {
        this.processingAllItems = true;
      } else {
        if (this.tabSelected == 2) {
          this.getNotInSequence();
          return;
        }
        this.arrayList = [];
        this.total = 0;
        if (this.filters != this.lastFilters) {
          this.getTotal();
        }
        this.onlyTotal = 0;
        this.loading = false;
      }
      this.filters.cantPerPage = this.pagination.cantPerPage;
      this.filters.currentPage = this.pagination.currentPage;
      this.filters.searchFilter = this.searchFilter;
      this.filters.only_total = 0;

      businessContactsService
        .getAll4(
          this.pagination.cantPerPage,
          this.pagination.currentPage,
          this.targetId,
          this.onlyTotal,
          this.searchFilter,
          allItems
        )
        .then((response) => {
          if (response) {
            if (allItems == 1) {
              this.arrayListAllItems = response.list;
              this.download()
              this.processingAllItems = false;
            } else {
              this.arrayList = response.list;
              this.arrayList = response.list.map(item => {
                if (typeof item.phone === 'string') {
                  const cleaned = item.phone.trim();
                  item.phone = cleaned === '' ? null : cleaned;
                } else if (item.phone == null) {
                  item.phone = null;
                }
                return item;
              });
              this.stepSeparate();
            }
          }
          this.lastFilters = this.filters;
          this.loading = true;
        });
    },

    getTotal() {
      this.loadingTotal = false;
      this.filters.cantPerPage = this.pagination.cantPerPage;
      this.filters.currentPage = this.pagination.currentPage;
      this.filters.only_total = 1;
      this.onlyTotal = 1;

      businessContactsService
        .getAll4(
          this.pagination.cantPerPage,
          this.pagination.currentPage,
          this.targetId,
          this.onlyTotal,
          this.searchFilter
        )
        .then((response) => {
          if (response) {
            this.total = response.total;
            this.totalStats = response;

            //inicializo las cuatro filas, una del total y las otras tres de los diferentes status
            for (let index = 0; index < 4; index++) {
              this.stepTotals.push({
                [`empty_field`]: "",
              });
            }
            this.totalStats.stats.forEach((item) => {
              //inicializar el total en 0
              if (this.stepTotals[0][`_step${item.step}`] == null) {
                this.stepTotals[0][`_step${item.step}`] = 0;
              }

              //posicion 0 del array es el total de cada step
              this.stepTotals[0][`_step${item.step}`] =
                item.total + this.stepTotals[0][`_step${item.step}`];

              //posicion 1 es el total de cada step para status 1 (por enviar)
              //posicion 2 es el total de cada step para status 2 (enviado)
              //posicion 3 es el total de cada step para status 3 (bounces)

              this.stepTotals[item.campaign_step_business_contact_status_id][
                `_step${item.step}`
              ] = item.total;
              this.stepTotals[item.campaign_step_business_contact_status_id][
                `_step${item.step}_status`
              ] = item.campaign_step_business_contact_status_id;

              this.stepTotals[item.campaign_step_business_contact_status_id][
                `_step${item.step}_status_name`
              ] =
                this.typeStatus[item.campaign_step_business_contact_status_id];

              this.stepTotals[item.campaign_step_business_contact_status_id][
                `_step${item.step}_prc`
              ] = (
                (item.total / this.stepTotals[0][`_step${item.step}`]) *
                100
              ).toFixed(2);
            });

            //elimina los status que no aparecen en ningun step
            this.stepTotals = this.stepTotals.filter((item) => {
              const keys = Object.keys(item); //keys es usado para recorrer dentro de cada posicion, cada atributo que contengan ellos

              //verifica en cada posicion, si existe un atributo que comience con _step,
              // si es un status vacio, no contendra ningun step y si no existe ningun step, elimina la posicion del array en stepTotals
              return keys.some((key) => key.startsWith("_step"));
            });

            this.stepTotals.forEach((item) => {
              if (item._step1 != undefined) {
                let porc = ((item._step1 / this.total) * 100).toFixed(0);
                item._step1 = item._step1 + " (" + porc + "%)";
              }

              for (let i = 2; i <= 6; i++) {
                if (
                  item[`_step${i}`] != undefined ||
                  item[`_step${i}`] != null
                ) {
                  let porc = ((item[`_step${i}`] / this.total) * 100).toFixed(
                    0
                  );
                  item[`_step${i}`] = item[`_step${i}`] + " (" + porc + "%)";
                }
              }
            });
          }
        })
        .finally(() => {
          this.loadingTotal = true;
        });
    },
  },
};
</script>
<style>
.icon-small {
  font-size: 1rem !important;
}

.icon-small-clock {
  font-size: 0.7rem !important;
}

.table-small {
  font-size: 10px !important;
}
</style>
